import { useState } from 'react';

import useToast, { ToastType } from '~/hooks/useToast';
import { trpc } from '~/trpc';
import { downloadCsv, formatAsCsv } from '~/utils';

const useExportOrgMembersInfo = () => {
  // Track loading state during export operation
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueToast } = useToast();

  const exportOrgMembersInfo = async () => {
    setIsLoading(true);
    try {
      // Small timeout to ensure loading state is visible to provide feedback to user
      await new Promise((resolve) => setTimeout(resolve, 300));

      const { dataToExport } = await trpc.orgs.getOrgMembersCSV.query();

      downloadCsv({
        csvData: formatAsCsv(dataToExport),
        filename: 'org-members-info.csv'
      });

      enqueueToast({
        message: 'Organization members info exported successfully',
        type: ToastType.SUCCESS
      });
    } catch (error) {
      console.error('Failed to export organization members info:', error);
      enqueueToast({
        message: 'Failed to export organization members info',
        type: ToastType.ERROR
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    exportOrgMembersInfo,
    isLoading
  };
};

export default useExportOrgMembersInfo;
